import type { TealiumDataLayer } from "@/lib/tealium/types";

export function tealiumView(data: TealiumDataLayer) {
  if (typeof window === "undefined") return;
  if (!window.utag?.view) return;

  // merge with existing data layer
  window.utag_data = {
    ...window.utag_data,
    ...data,
  };

  window.utag.view(window.utag_data);
}

export function tealiumLink(data: TealiumDataLayer) {
  if (typeof window === "undefined") return;
  if (!window.utag?.link) return;

  window.utag.link(data);
}
